@use "~theme/typographyV2" as typography;

.listItem {
  list-style-type: none;
  display: block;
  height: 66px;
  border-bottom: 1px solid var(--blue-01-at-30);

  &:last-child {
    border-bottom: none;
  }
}

.modal {
  padding: 0;
  border-radius: 8px;
  max-width: 342px;
  box-shadow: 0 2px 6px var(--gray-03);
  background-color: var(--gray-04);
}

.list {
  margin: 8px;
  padding: 0;
  border: 1px solid var(--gray-04);
  box-shadow: 0 2px 6px var(--gray-03);
  background-color: var(--white);
  border-radius: 8px;
}

.icon {
  height: 36px;
  width: 36px;
}

.link {
  @include typography.body;
  text-decoration: none;
  color: var(--black);
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 1;
  height: 100%;
  padding: 0;
}
